import { errorsMixin } from './Errors.js';
import { analytics } from './../analytics';

export default {
    mixins: [errorsMixin],
    methods: {
        accept(consentsData = {}) {
            this.loading = true;

            const analyticsData = {
                selected_amount: this.selectedAmount,
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user_id ?? this.user?.id ?? null,
                page_name: this.gTagPageName ?? 'WELCOME',
                consents: consentsData
            };

            analytics.marketPlaceSignUpEvents.nextButtonClickedEvent(analyticsData);

            this.$http
                .post(`/signup/welcome/${this.loan.id}`, {
                    adult_check: this.adult_check,
                    bankruptcy_check: this.bankruptcy_check,
                    selected_amount: this.selectedAmount,
                    consents: consentsData
                })
                .then(() => {

                    analytics.marketPlaceSignUpEvents.nextButtonClickedSuccess(analyticsData);

                    window.location.reload();
                })
                .catch(err => {
                    this.handleError(err);
                    this.loading = false;

                    analytics.marketPlaceSignUpEvents.nextButtonClickedError(analyticsData);
                });
        },
    },
}